import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Vehicles.css";
import { logHistory } from "../../utils/historyLogger";

function Vehicles() {
  const [vehicles, setVehicles] = useState([]);
  const role = localStorage.getItem("role");

  const canEdit = role === "admin" || role === "superadmin";
  const canDelete = role === "superadmin";
  // Any logged-in role (user, admin, superadmin) can add data now.
  const canAdd = role === "user" || role === "admin" || role === "superadmin";

  const [search, setSearch] = useState("");
  const [editingId, setEditingId] = useState(null);

  const [formData, setFormData] = useState({
    date: "",
    vehicleNumber: "",
    vehicleType: "",
    driverName: "",
    driverContact: "",
    reason: "",
    itemType: "",
    department: "",
    companyVehicle: "Yes",
    status: "Pending",
  });

  useEffect(() => {
    fetchVehicles();
  }, []);

  const fetchVehicles = async () => {
    try {
      const res = await axios.get("https://hrpsc.swisstekaluminium.com/api/vehicles");
      setVehicles(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.log(err);
      alert("Failed to fetch data");
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const clearForm = () => {
    setFormData({
      date: "",
      vehicleNumber: "",
      vehicleType: "",
      driverName: "",
      driverContact: "",
      reason: "",
      itemType: "",
      department: "",
      companyVehicle: "Yes",
      status: "Pending",
    });

    setEditingId(null);
  };
    const handleSubmit = async () => {
    try {
      if (!formData.vehicleNumber || !formData.vehicleType) {
        alert("Please fill required fields");
        return;
      }

      if (editingId) {
        await axios.put(
          `https://hrpsc.swisstekaluminium.com/api/vehicles/${editingId}`,
          formData
        );

        await logHistory(
          "Vehicles",
          "Updated Vehicle",
          `Vehicle ${formData.vehicleNumber} updated`
        );

        alert("Vehicle Updated Successfully");
      } else {
        await axios.post("https://hrpsc.swisstekaluminium.com/api/vehicles", formData);

        await logHistory(
          "Vehicles",
          "Added Vehicle",
          `Vehicle ${formData.vehicleNumber} added`
        );

        alert("Vehicle Added Successfully");
      }

      fetchVehicles();
      clearForm();
    } catch (err) {
      console.log(err);
      alert("Something went wrong");
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Delete this vehicle?");

    if (!confirmDelete) return;

    try {
      await axios.delete(`https://hrpsc.swisstekaluminium.com/api/vehicles/${id}`);

      await logHistory(
        "Vehicles",
        "Deleted Vehicle",
        "Vehicle deleted"
      );

      fetchVehicles();
    } catch (err) {
      console.log(err);
      alert("Delete Failed");
    }
  };

  const handleEdit = (item) => {
    setEditingId(item.id);

    setFormData({
      date: item.date ? item.date.substring(0, 10) : "",
      vehicleNumber: item.vehicleNumber || "",
      vehicleType: item.vehicleType || "",
      driverName: item.driverName || "",
      driverContact: item.driverContact || "",
      reason: item.reason || "",
      itemType: item.itemType || "",
      department: item.department || "",
      companyVehicle: item.companyVehicle || "Yes",
      status: item.status || "Pending",
    });

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
    const downloadCSVReport = () => {
    if (vehicles.length === 0) {
      alert("No data to download");
      return;
    }

    const headers = Object.keys(vehicles[0]);

    const rows = vehicles.map((item) =>
      headers
        .map((field) => `"${String(item[field] ?? "").replace(/"/g, '""')}"`)
        .join(",")
    );

    const csvContent = [headers.join(","), ...rows].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "vehicles_report.csv";
    link.click();

    URL.revokeObjectURL(url);
  };

  const filteredVehicles = vehicles.filter((item) => {
    const text = search.toLowerCase();

    return (
      item.vehicleNumber?.toLowerCase().includes(text) ||
      item.driverName?.toLowerCase().includes(text) ||
      item.vehicleType?.toLowerCase().includes(text)
    );
  });

  const companyVehicles = vehicles.filter(
    (item) => item.companyVehicle === "Yes"
  );

  const outsideVehicles = vehicles.filter(
    (item) => item.companyVehicle === "No"
  );

  return (
    <div className="vehicle-page">
      <h1 className="page-title">Vehicle Updates</h1>

      <div className="dashboard-cards">
        <div className="dashboard-card">
          <h3>Total Vehicles</h3>
          <h1>{vehicles.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Company Vehicles</h3>
          <h1>{companyVehicles.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Outside Vehicles</h3>
          <h1>{outsideVehicles.length}</h1>
        </div>
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search Vehicle No or Driver"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <button className="clear-btn" onClick={() => setSearch("")}>
          Clear
        </button>

        <button className="add-btn" onClick={downloadCSVReport}>
          Download Report
        </button>
      </div>

      {(canAdd || editingId) && (
        <div className="form-container">
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
          />

          <input
            type="text"
            name="vehicleNumber"
            placeholder="Vehicle Number"
            value={formData.vehicleNumber}
            onChange={handleChange}
          />

          <input
            type="text"
            name="vehicleType"
            placeholder="Vehicle Type"
            value={formData.vehicleType}
            onChange={handleChange}
          />

          <input
            type="text"
            name="driverName"
            placeholder="Driver Name"
            value={formData.driverName}
            onChange={handleChange}
          />

          <input
            type="text"
            name="driverContact"
            placeholder="Driver Contact"
            value={formData.driverContact}
            onChange={handleChange}
          />
                <input
            type="text"
            name="reason"
            placeholder="Reason"
            value={formData.reason}
            onChange={handleChange}
          />

          <input
            type="text"
            name="itemType"
            placeholder="Item Type"
            value={formData.itemType}
            onChange={handleChange}
          />

          <input
            type="text"
            name="department"
            placeholder="Department"
            value={formData.department}
            onChange={handleChange}
          />

          <select
            name="companyVehicle"
            value={formData.companyVehicle}
            onChange={handleChange}
          >
            <option value="Yes">Company Vehicle</option>
            <option value="No">Outside Vehicle</option>
          </select>

          <button className="add-btn" onClick={handleSubmit}>
            {editingId ? "Update Vehicle" : "Add Vehicle"}
          </button>

          <button className="clear-btn" onClick={clearForm}>
            Clear Form
          </button>
        </div>
      )}

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Vehicle No</th>
              <th>Type</th>
              <th>Driver</th>
              <th>Contact</th>
              <th>Reason</th>
              <th>Item Type</th>
              <th>Department</th>
              <th>Vehicle</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredVehicles.length > 0 ? (
              filteredVehicles.map((item) => (
                <tr key={item.id}>
                  <td>{item.date ? item.date.substring(0, 10) : ""}</td>
                  <td>{item.vehicleNumber}</td>
                  <td>{item.vehicleType}</td>
                  <td>{item.driverName}</td>
                  <td>{item.driverContact}</td>
                  <td>{item.reason}</td>
                  <td>{item.itemType}</td>
                  <td>{item.department}</td>

                  <td>
                    <button
                      className={
                        item.companyVehicle === "Yes"
                          ? "status-company"
                          : "status-outside"
                      }
                    >
                      {item.companyVehicle === "Yes" ? "Company" : "Outside"}
                    </button>
                  </td>

                  <td>
                    {canEdit && (
                      <button
                        className="edit-btn"
                        onClick={() => handleEdit(item)}
                      >
                        Edit
                      </button>
                    )}

                    {canDelete && (
                      <button
                        className="delete-btn"
                        onClick={() => handleDelete(item.id)}
                      >
                        Delete
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="10"
                  style={{
                    textAlign: "center",
                    padding: "30px",
                    color: "gray",
                  }}
                >
                  No Records Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Vehicles;